import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarText',
  pure: true,
})
export class AvatarTextPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || value === '') {
      return '';
    }

    return value.split(' ')
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');
  }
}
